import React, {useLayoutEffect} from 'react'

import FormError from "../../../../../../../core/gd-form/common/form-error/form-error"
import FieldsFactory from "../../../../../../../core/fields3/fields-factory"
import {FieldType} from "../../../../../../../core/fields3/field-type"
import getViewLocationOptions from "../../../../../../../core/model2/custom-view/actions/get-view-location-options"
import FieldFormElement from "../../../../../../../core/fields3/render/form-elemnent"
import CustomView from "../../../../../../../core/model2/custom-view/custom-view"
import FormManager from "../../../../../../../core/gd-form/common/form-manager"
import Workspace from "../../../../../../../core/model2/space/workspaces/workspace"
import {PopoverMenuItemType} from "../../../../../../../core/gd-components/popover-menu/popover-menu/const"
import FieldFormElementView from "../../../../../../../core/fields3/render/form-elemnent-view"

type Props = {
    view        : CustomView
    form        : FormManager

    onChange?   : func
}

// const debug = "ViewLocation"
const debug = false

export default function ViewLocation(props: Props) {

    debug && console.log(debug, "view=", props.view)

    const onUserChangeLocation = () => {
        const location = props.form.getValue('location')
        const workspace = gd.spaces.workspaces.getByProjectId(location)
        props.view.parentProjectId = workspace?.project.id || undefined
        props.onChange?.()
    }

    useLayoutEffect(() => {
        props.form.fields['location'].onUserChange = onUserChangeLocation
    }, []);

    if (props.view.parentProjectId && !gd.spaces.workspaces.getByProjectId(props.view.parentProjectId)) {
        return (
            <div className="row">
                <div className="label">Display in:</div>
                <div className="element">
                    <FieldFormElementView field={gd.fields.project.parentId}
                                          model={{parentId: props.view.parentProjectId}}
                                          disabled={true}/>
                </div>
            </div>
        )
    }

    const options = getViewLocationOptions(props.view.type)
    if (!gd.spaces.workspaces.isEmpty) {
        options.push({
            type: PopoverMenuItemType.SEPARATOR
        })
    }

    _.map(gd.spaces.workspaces.models, (workspace: Workspace) => {
        options.push({
            value   : workspace.project.id,
            icon    : workspace.icon,
            label   : workspace.title,
        })
    })

    debug && console.log(debug, 'render', options)

    const field = FieldsFactory.get({
        fieldId         : 'location',
        type            : FieldType.DROPDOWN,
        options         : options,
        noValueOption   : false,
        showMenuMore    : false
    })

    return (
        <div className="row">
            <div className="label">Display in:</div>
            <div className="element">
                <FieldFormElement field={field} form={props.form}/>

                <FormError form={props.form} name="location" />
            </div>
        </div>
    )
}